import { render, staticRenderFns } from "./PlanHeader.vue?vue&type=template&id=23d43f9a"
import script from "./PlanHeader.vue?vue&type=script&lang=js"
export * from "./PlanHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports